import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modal: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderWidth: 0,
  },
  container: {
    flex: 1,
    backgroundColor: '#000',
    opacity: 0.6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBox: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    justifyContent: 'center',
  },
  modalContentLarge: {
    backgroundColor: '#fff',
    width: '30%',
    height: '30%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modalContentSmall: {
    backgroundColor: '#fff',
    width: '80%',
    height: 250,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modalImageContainer: {
    position: 'absolute',
    top: -40,
    zIndex: 100,
    borderRadius: 45,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    width: 90,
    height: 90,
  },
  modaIconContainer: {
    position: 'absolute',
    top: -30,
    zIndex: 100,
    borderRadius: 35,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    width: 70,
    height: 70,
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
    padding: 5,
  },
  modalText: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
  modalTextContainer: {
    flex: 0.3,
    alignSelf: 'center',
    justifyContent: 'center',
    marginVertical: 10,
  },
  modalBtnContainer: {
    flex: 0.3,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  confirmBtnStyle: {
    backgroundColor: '#FFFFFF',
    height: '65%',
  },
  confirmBtnStyleSmall: {
    backgroundColor: '#FFFFFF',
    height: '82%',
  },
  confirmBtnText: {
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    textAlign: 'center',
  },
  cancelBtnStyle: {
    backgroundColor: '#FFFFFF',
    height: '65%',
  },
  cancelBtnStyleSmall: {
    backgroundColor: '#FFFFFF',
    height: '82%',
  },
  cancelBtnText: {
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    textAlign: 'center',
  },
});
